import React from 'react';
import { cn, getStatusColor, getStatusDotColor } from '../../lib/utils';

export const StatusBadge = ({ status, isOnline = true, showDot = true, socPercent = null }) => {
  // If charger is offline, override status to show "Offline"
  // But keep "Reconnecting" status as-is (grace period)
  const displayStatus = (!isOnline && status !== 'Offline' && status !== 'Reconnecting') ? 'Offline' : status;
  const isAvailable = displayStatus === 'Available';
  const isCharging = displayStatus === 'Charging';
  const isPreparing = displayStatus === 'Preparing';
  const isReconnecting = displayStatus === 'Reconnecting';
  
  return (
    <span className={cn('status-badge', getStatusColor(displayStatus))}>
      {showDot && !isCharging && !isPreparing && !isReconnecting && (
        <span 
          className={cn(
            'dot', 
            getStatusDotColor(displayStatus),
            isAvailable && 'animate-pulse-ping'
          )} 
        />
      )}
      {showDot && isCharging && (
        <div className="bolt red">
          <span className="base"></span>
          <span className="glow"></span>
        </div>
      )}
      {showDot && isPreparing && (
        <span className="dot bg-orange-500 animate-pulse" />
      )}
      {showDot && isReconnecting && (
        <span className="dot bg-yellow-500 animate-pulse" />
      )}
      {displayStatus === 'Available' ? 'I Lirë' : 
       displayStatus === 'Charging' ? (
         socPercent != null ? `Duke karikuar ${socPercent}%` : 'Duke karikuar'
       ) :
       displayStatus === 'Occupied' ? 'I zënë' :
       displayStatus === 'Preparing' ? 'Përgatitje' :
       displayStatus === 'Finishing' ? 'I zënë' :
       displayStatus === 'Faulted' ? 'Me defekt' :
       displayStatus === 'Unavailable' ? 'I padisponueshëm' :
       displayStatus === 'Offline' ? 'Offline' :
       displayStatus === 'Reconnecting' ? 'Duke u rilidhur...' :
       displayStatus}
    </span>
  );
};

export default StatusBadge;
